import React from "react";
import Topheader from '../components/Topheader';

export default function TournamentRules() {
  return (
    <>
    <Topheader colorbox="newfaq_header_color" title="Tournament Rules" />
      <div className="container py-3">
          <ul style={{paddingLeft:"15px", fontWeight:"500"}}>
            <li>
              Tournaments start at scheduled times, and seating is assigned
              randomly.
            </li>
            <li>
              The tournament concludes when one player has accumulated all the
              chips in play.
            </li>
            <li>
              Players who lose all their chips are eliminated, unless re-entries
              or re-buys are permitted.
            </li>
            <li>
              If two or more players are eliminated in the same hand, the player
              who started the hand with more chips will finish in the higher
              position.
            </li>
            <li>
              A Time Bank provides additional decision time that players may use
              when needed. Time can be drawn from the bank until it is fully
              exhausted.
            </li>
            <li>
              All standard poker tournament rules apply to Multi-Table
              Tournaments (MTTs).
            </li>
            <li>
              Tournaments award free play chips or reward Points as prizes. No
              real money is distributed at any stage.
            </li>
            <li>
              The App store has no involvement in hosting of the tournament or the distribution of Reward Points or free play chips as prizes.
            </li>
          </ul>
        </div>
    </>
  );
}
